import { APIGet } from '../utils/SingleLoginApi'

export interface PasswordPolicy {
  minimumLength: number
}

let cachedPolicy: PasswordPolicy | null = null

export const getPasswordPolicy = async (): Promise<PasswordPolicy> => {
  if (cachedPolicy) {
    return cachedPolicy
  }

  try {
    const policy = await APIGet<PasswordPolicy>('api/sso/config/password-policy')
    cachedPolicy = policy
    return policy
  } catch (error) {
    console.error('Failed to fetch password policy, using default:', error)
    // Fallback to default value
    const defaultPolicy = { minimumLength: 15 }
    cachedPolicy = defaultPolicy
    return defaultPolicy
  }
}

export const getMinimumPasswordLength = async (): Promise<number> => {
  const policy = await getPasswordPolicy()
  return policy.minimumLength
}
